import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@shadcn/ui/card";
import { createFileRoute, Link } from "@tanstack/react-router";
import Logo from "@/src/presentation/components/logo";
import ViewmodelWrapper from "@/src/presentation/components/viewmodel-wrapper";
import ResetPasswordViewModel from "@/src/presentation/view-models/reset-password-viewmodel";
import BackToLoginButton from "./_components/back-to-login-button";
import MainForm from "./_components/main-form";
import State from "./_components/state";

export const Route = createFileRoute("/_public/reset-password/")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  return (
    <ViewmodelWrapper type={ResetPasswordViewModel}>
      <State />
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="w-full max-w-md">
          <Logo />
          <Card className="border-brand-accent-subtle shadow-lg">
            <CardHeader className="space-y-1">
              <CardTitle className="text-2xl font-bold text-center">Reset Password</CardTitle>
              <CardDescription className="text-center">
                Create a new password for your account
              </CardDescription>
            </CardHeader>
            <CardContent>
              <MainForm />
            </CardContent>
            <CardFooter className="flex flex-col gap-y-4">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <span className="w-full border-t" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-card px-2 text-muted-foreground">Or</span>
                </div>
              </div>

              <BackToLoginButton />
            </CardFooter>
          </Card>

          <div className="mt-4 text-center text-sm text-muted-foreground">
            <p>
              Didn&apos;t receive email?{" "}
              <Link
                to="/forgot-password"
                className="text-brand-accent hover:text-brand-accent hover:underline"
              >
                Resend
              </Link>
            </p>
          </div>
        </div>
      </div>
    </ViewmodelWrapper>
  );
}
